export default "__VITE_ASSET__RHALaDw4__"